<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">报障统计
          <!-- <span v-if="companyInfo.COMPANY_NAME"> - {{companyInfo.COMPANY_NAME}}</span> -->
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.9rem;padding-top:1rem;padding-bottom:2rem;">
        <div style="box-shadow:0 0 14px 0 rgba(0,0,0,.08);">
          <v-card flat style="padding-bottom:0.2rem;">
            <div style="padding:0.5rem;padding-bottom:0;font-size:0.8rem;position: relative;">
              <!-- 最近7天新增报障统计 -->
              {{weekRadioGroup[weekRadio]}}新增报障统计
              <div style="position: absolute; display: inline-block; right: 5px; top: 0;">
                <!-- <v-menu left bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <v-radio-group v-model="weekRadio" style="padding: 0 10px;background:#fff">
                    <v-radio
                      v-for="(item, index) in weekRadioGroup"
                      :key="index"
                      :label="item"
                      :value="index"
                    ></v-radio>
                  </v-radio-group>
                </v-menu> -->
                <div>
                  <select id="us-select-week" style="color:#808080;outline:none;font-size:14px;position:absolute;right:1.4rem;direction: rtl;top:5px;" v-model="weekRadio">
                    <option :value="index" v-for="(item,index) in weekRadioGroup" :key="index">{{item}}</option>
                  </select>
                  <i class="fa fa-angle-down" aria-hidden="true" style="font-size:20px;color:#808080;position:absolute;right:0.2rem;pointer-events:none;top:5px;" ></i>
                </div>
              </div>
            </div>
            <v-divider style="margin-top:0.5rem;" />
            <E7dayStat ref="day_stat" id="chart1" :data="weekStatData" />
          </v-card>
        </div>
        <div style="margin-top:1rem;box-shadow:0 0 14px 0 rgba(0,0,0,.08);">
          <v-card flat style="padding-bottom:0.2rem;">
            <div style="padding:0.5rem;padding-bottom:0;font-size:0.8rem;position: relative;">
              <!-- 最近6个月新增报障统计 -->
              {{monthRadioGroup[monthRadio]}}新增报障统计
              <div style="position: absolute; display: inline-block; right: 5px; top: 0;">
                <!-- <v-menu left bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <v-radio-group v-model="monthRadio" style="padding: 0 10px;background:#fff">
                    <v-radio
                      v-for="(item, index) in monthRadioGroup"
                      :key="index"
                      :label="item"
                      :value="index"
                    ></v-radio>
                  </v-radio-group>
                </v-menu> -->
                <div>
                  <select id="us-select-month" style="color:#808080;outline:none;font-size:14px;position:absolute;right:1.4rem;direction: rtl;top:5px;" v-model="monthRadio">
                    <option :value="index" v-for="(item,index) in monthRadioGroup" :key="index">{{item}}</option>
                  </select>
                  <i class="fa fa-angle-down" aria-hidden="true" style="font-size:20px;color:#808080;position:absolute;right:0.2rem;pointer-events:none;top:5px;" ></i>
                </div>
              </div>
            </div>
            <v-divider style="margin-top:0.5rem;" />
            <E6monthStat ref="month_stat" id="chart2" :data="monthStatData" />
          </v-card>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import E7dayStat from './components/E7dayStatV2';
import E6monthStat from './components/E6monthStatV2';
export default {
  components: { E7dayStat, E6monthStat },
  props: {},
  data() {
    return {
      weekStatData: {
        labels: ['06-06', '06-07', '06-08', '06-09', '06-10', '06-11', '06-12'],
        values: [0, 0, 0, 0, 0, 0, 0]
      },
      monthStatData: {
        legend: ['数量'],
        labels: ['20-04', '20-05', '20-06', '20-07', '20-08', '20-09'],
        values: [0, 0, 0, 0, 0, 0]
      },
      companyInfo: {},
      weekRadio: 0,
      weekRadioGroup: ['最近7天', '上周'],
      monthRadio: 0,
      monthRadioGroup: ['最近6个月', '今年前半年', '去年后半年', '去年前半年']
    };
  },
  watch: {
    weekRadio() {
      this.getLast7DayStat()
    },
    monthRadio() {
      this.getLast3MonthStat()
    }
  },
  computed: {},
  mounted() {
    var that = this;
    that.companyInfo = that.$AppHelper.getCustomData('company_info');
    that.getWeekList()
    that.getMonthsList()
    that.$nextTick(() => {
      that.getLast7DayStat()
      that.getLast3MonthStat()
    })
    that.windowSize()
  },
  created() {},
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    goBack: function() {
      var that = this;
      that.$router.goBack()
    },
    getLast7DayStat() {
      var that = this
      that.$api.bz.statQueryByDays({ type: that.weekRadio, state: 1 }).then(res => {
        if (!res.success) {
          // that.$toast.warning('获取统计数据失败');
          console.log('获取报障按天统计数据失败', res);
          return
        }
        that.weekStatData = res.data
      })
    },
    getLast3MonthStat() {
      var that = this
      that.$api.bz.statQueryByMonths({ type: that.monthRadio, state: 1 }).then(res => {
        if (!res.success) {
          // that.$toast.warning('获取统计数据失败');
          console.log('获取报障按月统计数据失败', res);
          return
        }
        that.monthStatData = res.data
      })
    },
    getMonthsList() {
      var that = this
      that.$api.bz.getMonthsList().then(res => {
        if (!res.success) {
          console.log('获取月份数据失败', res);
          return
        }
        // console.log(res.data)
        that.monthRadioGroup = res.data
      })
    },
    getWeekList() {
      var that = this
      that.$api.bz.getWeekList().then(res => {
        if (!res.success) {
          console.log('获取星期数据失败', res);
          return
        }
        // console.log(res.data)
        that.weekRadioGroup = res.data
      })
    },
    windowSize() {
      var that = this
      // 监听窗口大小
      window.onresize = () => {
        return (() => {
          that.$nextTick(() => {
            that.$refs.day_stat.reloadSize()
            that.$refs.month_stat.reloadSize()
          })
        })()
      }
    }
  }
};
</script>

<style scoped>

.us-v-app{
  background-color: #f2f2f2;
}

.us-back-lucency {
  background-color: rgba(255, 255, 255, 0.08) !important;
  color: #fff !important;
  cursor: pointer;
  box-shadow: 1px 1px 5px 1px rgba(255, 255, 255, 0.4) !important;
}
.us-lucency-border {
  border-top: 1px solid #f5f5f5;
}
.v-menu__content {
  background: #fff;
}
</style>
